import { Box, InputAdornment, IconButton } from "@material-ui/core"
import { navigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import { TemplateProps } from "../../journeys/journey/Interfaces"
import './inventory.css'
import AmsTypography from "../../atoms/AmsTypography/AmsTypography"
import AmsButton from "../../atoms/AmsButton/AmsButton"
import SingleInventory from "../../atoms/SingleInventory/SingleInventory"
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from "../../context";
import axios from "axios"
import actionTypeConstants from "../../utils/actionTypeConstants";
import { getMobileOperatingSystem } from "../../utils/helpers";
import { makeStyles } from '@material-ui/core/styles';
import { getUniqueRoomsFromInventory } from "../../utils/roomHelper"
import { forEach } from "lodash"


const createInventoryApiEndPoint = process.env["REACT_APP_CREATE_INVENTORY"]

const inventorey_api_key = process.env["REACT_APP_INVENTORY_API_KEY"];

const sendMailAPI = process.env["REACT_APP_SEND_EMAIL"];


const useStyles = makeStyles({
    baseContainerBlock: {
        height: '90vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    buttonContainer: {
        // padding: (props:any) => props?.os==="iOS" ? "4vw": "1vw",
        // width: "90%",
        background: "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%)",
        marginBottom: (props: any) => props?.os === "iOS" ? "0px" : "0px",
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        //   height:'100px'
    },
});
const Inventory: React.FC<TemplateProps> = (props: any) => {

    const { templateProps } = props
    const { title, btnProps, inventoryItems, btnPropsTwo } = templateProps
    const [inventory, setInventory] = useState<any>([]);
    const [additionalItems, setAdditionalItems] = useState<any>([]);
    const [btnDisable, setBtnDisable] = useState<Boolean>(true)
    let os: any = getMobileOperatingSystem();
    const classes = useStyles({ os: os });

    let isBtnDisable: any = sessionStorage.getItem("inventoryButton");

    if (isBtnDisable) {
        isBtnDisable = isBtnDisable === "true"
    }

    const customerContext: any = useContextSelector(
        StoreContext,
        (store) => store?.appState?.customerJourneyContext
    )

    const getInventoryList = (allRoomObj: any) => {
        const filteredArray = allRoomObj.flatMap((roomObj: any) => {
            const roomName = Object.keys(roomObj)[0];
            const roomItems = roomObj[roomName];
            const filteredItems = roomItems.filter((item: any) => item.quantity > 0);
            return filteredItems;
        });

        return filteredArray
    }

    useEffect(() => {
        let rooms = customerContext?.rooms;

        let roomObj = sessionStorage.getItem('roomInfo')
        if (roomObj) {
            roomObj = JSON.parse(roomObj)
            const inventoryList = getInventoryList(roomObj)

            setInventory(inventoryList)
        }

        let additionalItemList: any = sessionStorage.getItem("additionalItems");

        if (additionalItemList) {
            additionalItemList = JSON.parse(additionalItemList);
            // Convert to a flat array
            const result = Object.values(additionalItemList).flat();
            setAdditionalItems(result)
        }

        setBtnDisable(isBtnDisable)
    }, [])

    const updateRoom = (inventoryList: any, allRoom: any) => {

        //console.log("Inventory List is : ", inventoryList, allRoom)
        inventoryList.forEach((inventoryItem: any) => {
            const itemIndex = inventoryItem.index;

            // Find the room containing the item with the matching index
            const roomContainingItem = allRoom.find((room: any) => {
                const roomItems = room[Object.keys(room)[0]];
                return roomItems.some((item: any) => item.index === itemIndex);
            });


            // Update the quantity of the matching item
            if (roomContainingItem) {

                const roomItems = roomContainingItem[Object.keys(roomContainingItem)[0]];
                const matchingItem = roomItems.find((item: any) => item.index === itemIndex);

                if (matchingItem) {
                    matchingItem.quantity = inventoryItem.quantity;
                }
            }
        });

        return allRoom

    }

    const sendEmail = async (data: any) => {
        // let data = {
        //     "customerId": customerContext?.customerDetails?.CustomerID,
        // }
        let response = await axios.post(`${sendMailAPI}`, data, {
            headers: {
                'x-api-key': inventorey_api_key,

            }
        })

        if (response) {
            console.log("Response is : ", response)

        }
    }

    const getAdditionItemInventory = () => {
        let newInventory: any = []
        additionalItems.map((item: any) => {
            let newInventoryObj = {
                ID: item?.ID,
                item: item?.item,
                CubesheetItemTypeID: item?.CubesheetItemTypeID,
                cubes: item?.cubes,
                defaultItem: item?.defaultItem,
                room: item?.room,
                quantity: item?.quantity,
                itemId: item?.itemId
            }

            newInventory.push(newInventoryObj)
        })

        return newInventory
    }

    const createInventory = async (inventoryData: any) => {

        let additionalInventoryData = getAdditionItemInventory()
        let newInventory = inventoryData.concat(additionalInventoryData)

        let data = {
            "customerId": customerContext?.customerDetails?.CustomerID,
            inventoryList: newInventory
        }

        let response = await axios.post(`${createInventoryApiEndPoint}`, data, {
            headers: {
                'x-api-key': inventorey_api_key,

            }
        })

        if (response) {
            sendEmail(data)
            navigate(btnProps?.nextScreen)

        }


    }

    useEffect(() => {
        sessionStorage.setItem('inventory', JSON.stringify(inventory))

        let roomObj: any = sessionStorage.getItem('roomInfo')
        if (roomObj) {
            roomObj = JSON.parse(roomObj)
            const newRooms = updateRoom(inventory, roomObj)
            sessionStorage.setItem('roomInfo', JSON.stringify(newRooms))
        }
        if (inventory.length > 0) {
            setBtnDisable(false); 
        } else {
            setBtnDisable(true); 
        }

    }, [inventory])

    const getRoom = (room: any, roomId: string) => {

        let roomInfo: any = sessionStorage.getItem('roomInfo');
        let itemRoom = "";
        if (roomInfo) {
            roomInfo = JSON.parse(roomInfo);
            let selectedRoom: any;
            roomInfo?.map((item: any) => {

                Object.entries(item).forEach((rooms): any => {
                    let roomDetails: any = rooms[1]
                    selectedRoom = roomDetails?.filter((singleRoom: any) => singleRoom?.item === room && singleRoom?.itemId === roomId)
                    if (selectedRoom?.length > 0) {
                        itemRoom = rooms[0]
                    }

                });
            })
        }

        if (itemRoom) {
            return itemRoom;
        }

    }

    const handleSubmit = async (event: any) => {

        setBtnDisable(true)
        sessionStorage.setItem("inventoryButton", "true");
        let inventoryItems: any = sessionStorage.getItem('inventory')
        if (inventoryItems) {
            inventoryItems = JSON.parse(inventoryItems);

            let inventoryList: any = [];
            let selectedItemsCount = 0;


            inventoryItems?.map((inventory: any) => {
                if (inventory?.quantity > 0) {
                    selectedItemsCount += inventory?.quantity;
                }
                 if (selectedItemsCount > 0) {
        setBtnDisable(false);
    } else {
        setBtnDisable(true);
    }

                let singleItem = {
                    item: inventory?.item,
                    cubes: inventory?.cubes,
                    quantity: inventory?.quantity,
                    itemId: inventory?.itemId,
                    room: getRoom(inventory?.item, inventory?.itemId)
                }

                inventoryList.push(singleItem);
            })


            

            let additionalInventoryData = getAdditionItemInventory()
            let newInventory = inventoryList.concat(additionalInventoryData)

            let data = {
                "customerId": customerContext?.customerDetails?.CustomerID,
                inventoryList: newInventory
            }

            sessionStorage.setItem("inventoryListData", JSON.stringify(data))
            // createInventory(inventoryList)


         }

        navigate(btnProps?.nextScreen)

    }

    const handleAnotherItem = async (event: any) => {
        navigate(btnPropsTwo?.nextScreen)
    }

    const handleDecrement = (index: any, count: any, room: any, id: any) => {

        let productList: any = [...inventory];
        if (count > 1) {

            productList.map((item: any) => {
                if (item?.index === index) {
                    item['quantity'] = item['quantity'] - 1;

                }
            })

            setInventory(productList)
        } else {
            //  adding the element removed from selected product into the list item again
            let newList = productList.filter((item: any) => item?.index !== index);

            let selectedRoom: any = sessionStorage.getItem("selectedRooms")
            let roomInfo: any = sessionStorage.getItem("roomInfo")

            if (selectedRoom) {

                selectedRoom = JSON.parse(selectedRoom);
                roomInfo = JSON.parse(roomInfo);

                //select particular room; 
                // roomInfo.map((item:any) => {

                // })

                const roomsUnique = getUniqueRoomsFromInventory(newList)

                const result = selectedRoom.filter((item: any) => newList.some((newListItem: any) => newListItem.room === item.room));
                if (roomInfo) {
                    roomInfo.forEach((element: any, index: any) => {
                        let singleRoom = Object.keys(element)[0];


                        if (singleRoom === room) {

                            element[singleRoom].forEach((roomItem: any) => {
                                if (roomItem?.itemId === id) {

                                    roomItem['quantity'] = 0
                                }

                            })
                        }



                    })
                }

                sessionStorage.setItem("selectedRooms", JSON.stringify(roomsUnique))
                sessionStorage.setItem("roomInfo", JSON.stringify(roomInfo))
            }


            setInventory(newList)

            sessionStorage.setItem("inventory", newList)


        }


    }
    const handleIncrement = (index: any, count: any) => {

        let inventoryList: any = [...inventory];
        inventoryList.map((item: any) => {
            if (item?.index === index) {
                item['quantity'] = item['quantity'] + 1;
            }
        })
        setInventory(inventoryList)
    }

    const handleExtraItemDecrement = (roomItem: any) => {
        let quantity = roomItem["quantity"] - 1;

        //if quantity is greater than zero simply add the quantity to the selected item
        if (quantity > 0) {
            const newSelectedExtraItemList = additionalItems.map(
                (item: any) => {
                    if (item?.itemId === roomItem?.itemId) {
                        item["quantity"] = quantity;
                    }
                    return item;
                }
            );

            setAdditionalItems(newSelectedExtraItemList);
        } else {
            //if quantity is zero
            //1. remove the item from selected List
            const FilteredExtraItemList = additionalItems.filter(
                (item: any) => item?.itemId !== roomItem?.itemId
            );

            setAdditionalItems(FilteredExtraItemList);

        }

    }

    const handleExtraItemIncrement = (roomItem: any) => {
        let quantity = roomItem["quantity"] + 1;
        const newSelectedExtraItemList = additionalItems.map((item: any) => {
            if (item?.itemId === roomItem?.itemId) {
                item["quantity"] = quantity;
            }
            return item;
        });

        setAdditionalItems(newSelectedExtraItemList);
    }



    return (
        <Box className={`${classes.baseContainerBlock} HomeBlock`} >
            <Box className="inventoryMainContainer">
                <Box className="title" mb={5}>
                    <AmsTypography variant="h1" text={title} />
                </Box>
                <Box >
                    <Box className="inventoryHeading" padding={'10px'} display={"flex"} justifyContent="space-between">
                        <Box>{"Item"}</Box>
                        <Box>{"Room"}</Box>
                        <Box>{"Quantity"}</Box>

                    </Box>
                    <Box className="inventoryDivider"></Box>
                </Box>

                <Box mb={5} mt={5}>
                    {inventory?.map((item: any, index: any) => {
                        return <SingleInventory onDecrementClick={() => handleDecrement(item?.index, item?.quantity, item?.room, item?.itemId)} onIncrementClick={() => handleIncrement(item?.index, item?.quantity)} key={index} text={item?.text} count={item?.quantity} room={item?.room} />
                    })}

                </Box>
                <Box mb={5} mt={5}>
                    {additionalItems?.map((item: any, index: any) => {

                        return <SingleInventory onDecrementClick={() => handleExtraItemDecrement(item)} onIncrementClick={() => handleExtraItemIncrement(item)} key={index} text={item?.text} count={item?.quantity} room={item?.room} />
                    })}

                </Box>
            </Box>
            <Box className="buttonContainerBlock" >
                <Box className={classes.buttonContainer}>
                    <AmsButton
                        attributes={btnPropsTwo?.attributes}
                        handleClick={handleAnotherItem}
                    />
                    <AmsButton
                        attributes={btnProps?.attributes}
                        handleClick={handleSubmit}
                        disable={btnDisable}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default Inventory




